module.exports = __webpack_public_path__ + "static/media/hwi3.36231673.webp";